import { render } from "./RemindersSection.vue?vue&type=template&id=a0e506ba&ts=true"
import script from "./RemindersSection.vue?vue&type=script&lang=ts"
export * from "./RemindersSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__